import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  Button,
  Chip,
  Paper,
} from "@mui/material";
// components
import { MHidden } from "../../components/@material-extend";
import Searchbar from "./Searchbar";
import FilterPopover from "./FilterPopover";
import { borders, width } from "@mui/system";
import { useRef, useState, useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useHistory, useLocation, useNavigate } from "react-router-dom";
import Label from "src/components/Label";
import FilterMenu from './filterMenu';


const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - 100%/6)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

function DashboardNavbar(props, { onOpenSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAudit, setIsAudit] = useState(false);
  const [sizeAnchorEl, setSizeAnchorEl] = useState(null);
  const [areaAnchorEl, setAreaAnchorEl] = useState(null);
  const [isMyPractice, setIsMyPractice] = useState(false);
  // Get filter state from Redux
  const selectedSizeFilters = props.filters.size || [];
  const selectedAreaFilters = props.filters.area || [];

  useEffect(() => {
    if (location.pathname.includes("practiceoverview")) {
      setIsMyPractice(true);
    } else {
      setIsMyPractice(false);
    }
  }, [location.pathname]);
  
  useEffect(() => {
    if (areaAnchorEl === null) {
      setTimeout(() => {
         if (isMyPractice) {
          props.loadData();
        } else {
          props.loadAntibioticData();
        }
      }, 100);
    }
  }, [areaAnchorEl]);

  useEffect(() => {
    if (sizeAnchorEl === null) {
      setTimeout(() => {
        if (isMyPractice) {
          props.loadData();
        } else {
          props.loadAntibioticData();
        }
      }, 100);
    }
  }, [sizeAnchorEl]);


  // Update the handle change functions
  const handleSizeChange = (value, checked) => {
    if (checked && selectedAreaFilters.length > 0) {
      props.updateFilter({ key: "area", value: [] });
    }
    const newSizeFilters = checked
      ? [...selectedSizeFilters, value]
      : selectedSizeFilters.filter(item => item !== value);
    
    props.updateFilter({ key: "size", value: newSizeFilters });
  };

  const handleAreaChange = (value, checked) => {
    if (checked && selectedSizeFilters.length > 0) {
      props.updateFilter({ key: "size", value: [] });
    }
    const newAreaFilters = checked
      ? [...selectedAreaFilters, value]
      : selectedAreaFilters.filter(item => item !== value);
    
    props.updateFilter({ key: "area", value: newAreaFilters });
  };

  // Add clear filters function
  const handleClearFilters = () => {
    props.updateFilter({ key: "size", value: [] });
    props.updateFilter({ key: "area", value: [] });
    setSizeAnchorEl(null);
    setAreaAnchorEl(null);
    
    // Trigger data refresh with cleared filters
    setTimeout(() => {
      if (isMyPractice) {
        props.loadData();
      } else {
        props.loadAntibioticData();
      }
    }, 100);
  };

  // Update the Grid container in the return statement

  const practiceSizeOptions = [
    { value: '<500', label: '<500 patients', checked: false, disabled: true },
    { value: '500-999', label: '500-999 patients', checked: false, disabled: true },
    { value: '1000-1499', label: '1000-1499 patients', checked: false, disabled: true },
    { value: '1500-1999', label: '1500-1999 patients', checked: false },
    { value: '>2000', label: '> 2000 patients', checked: false }
  ];

  const areaOptions = [
    { value: 1, label: 'Big City', checked: false, disabled: true },
    { value: 2, label: 'Sub-urban', checked: false },
    { value: 3, label: 'Small Town', checked: false },
    { value: 4, label: 'Rural', checked: false, disabled: true },
    { value: 5, label: 'Mixed Rural/Urban', checked: false }
  ];


  const areaOptions2 = {
    1: 'Big City',
    2: 'Sub-urban',
    3: 'Small Town',
    4: 'Rural',
    5: 'Mixed Rural/Urban'
  };


  const handleSizeClick = (event) => {
    if(sizeAnchorEl === null) {
      const action = isMyPractice ? "Practice Size Filter" : "Antibiotic Size Filter";
      const label = isMyPractice ? "Practice Public Dashboard" : "Antibiotic Public Dashboard";
      ReactGA.event({
        category: label,
        action: action,
        label: label,
        value: isMyPractice ? 1 : 2,
      });
    }
    if (selectedAreaFilters.length > 0) {
      props.updateFilter({ key: "area", value: [] });
    }
    setSizeAnchorEl(sizeAnchorEl ? null : event.currentTarget);
    setAreaAnchorEl(null);
  };

  const handleAreaClick = (event) => {
    if(areaAnchorEl === null) {
      const action = isMyPractice ? "Practice Area Filter" : "Antibiotic Area Filter";
      const label = isMyPractice ? "Practice Public Dashboard" : "Antibiotic Public Dashboard";
      ReactGA.event({
        category: label,
        action: action,
        label: label,
        value: isMyPractice ? 1 : 2,
      });
    }
    if (selectedSizeFilters.length > 0) {
      props.updateFilter({ key: "size", value: [] });
    }
    setAreaAnchorEl(areaAnchorEl ? null : event.currentTarget);
    setSizeAnchorEl(null);
  };

  return (
    <RootStyle>
      <ToolbarStyle>
        <Box sx={{ mx: 1, borderRadius: 0 }} dir="ltr" />
        <Grid container spacing={2}>
          <Grid container item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Left side - Size filter */}
            <Grid item xs={5} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                style={{ fontSize: "15px", width: "200px" }}
                variant="contained"
                onClick={handleSizeClick}
                disabled={selectedAreaFilters.length > 0}
              >
                { sizeAnchorEl === null ? 'Filter by practice size' : 'Apply Size Filter' }
              </Button>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {selectedSizeFilters.map((filter) => (
                  <Chip
                    key={filter}
                    label={filter}
                    size="small"
                    sx={{ m: 0.5 }}
                  />
                ))}
              </Box>
            </Grid>

            {/* Center - Clear button */}
            <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center' }}>
              {(selectedSizeFilters.length > 0 || selectedAreaFilters.length > 0) && (
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  sx={{ width: "200px" }}
                >
                  Clear Filters
                </Button>
              )}
            </Grid>

            {/* Right side - Area filter */}
            <Grid item xs={5} sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end' }}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'flex-end' }}>
                {selectedAreaFilters.map((filter) => {
                  const value = areaOptions2[filter];
                  return (
                    <Chip
                      key={value}
                      label={value}
                      size="small"
                      sx={{ m: 0.5 }}
                    />
                  );
                })}
              </Box>
              <Button
                style={{ fontSize: "15px", width: "200px" }}
                variant="contained"
                onClick={handleAreaClick}
                disabled={selectedSizeFilters.length > 0}
              >
                { areaAnchorEl === null ? 'Filter by area' : 'Apply Area Filter' }
              </Button>
            </Grid>
          </Grid>

          {/* Filter Menus */}
          <FilterMenu
            anchorEl={sizeAnchorEl}
            open={Boolean(sizeAnchorEl)}
            options={practiceSizeOptions.map(opt => ({
              ...opt,
              checked: selectedSizeFilters.includes(opt.value)
            }))}
            onClose={() => setSizeAnchorEl(null)}
            onChange={handleSizeChange}
          />
          <FilterMenu
            anchorEl={areaAnchorEl}
            open={Boolean(areaAnchorEl)}
            options={areaOptions.map(opt => ({
              ...opt,
              checked: selectedAreaFilters.includes(opt.value)
            }))}
            onClose={() => setAreaAnchorEl(null)}
            onChange={handleAreaChange}
          />
        </Grid>
      </ToolbarStyle>
    </RootStyle>
  );
}

const mapState = (state) => ({
  user: state.user,
  filters: state.filters,
});

const mapDispatch = ({
  user: { login, addDashboard },
  filters: { updateFilter, updateDateFilters, resetFilters },
  antibiotics: {
    getGeneralAB,
    promice_8,
    promice_2,
    promice_3_4,
    promice_5_6,
    promice_7,
    loadAntibioticData,
  },
  antibioticscomparisons: {
    getComparisonsAB,
    compare_1,
    compare_2,
    compare_3,
    compare_4,
    compare_5,
    compare_6,
    compare_7,
    pocompare_1,
    pocompare_2,
    pocompare_3,
    pocompare_4,
    pocompare_5,
    pocompare_6,
    pocompare_7,
  },
  overview: {
    loadData,
    getPromise_1,
    getPromise_2,
    getPromise_3,
    getPromise_4,
    getPromise_5,
    getPromise_6,
    getPromise_7,
  },
}) => ({
  login: (payload) => login(payload),
  addDashboard: (payload) => addDashboard(payload),
  resetFilters: () => resetFilters(),
  updateFilter: (payload) => updateFilter(payload),
  updateDateFilters: () => updateDateFilters(),
  getGeneralAB: () => getGeneralAB(),
  promice_8: () => promice_8(),
  promice_2: () => promice_2(),
  promice_3_4: (payload) => promice_3_4(payload),
  promice_5_6: () => promice_5_6(),
  promice_7: () => promice_7(),
  loadAntibioticData: () => loadAntibioticData(),
  getComparisonsAB: () => getComparisonsAB(),
  compare_1: () => compare_1(),
  compare_2: () => compare_2(),
  compare_3: () => compare_3(),
  compare_4: (payload) => compare_4(payload),
  compare_5: () => compare_5(),
  compare_6: () => compare_6(),
  compare_7: () => compare_7(),
  pocompare_1: () => pocompare_1(),
  pocompare_2: () => pocompare_2(),
  pocompare_3: () => pocompare_3(),
  pocompare_4: () => pocompare_4(),
  pocompare_5: () => pocompare_5(),
  pocompare_6: () => pocompare_6(),
  pocompare_7: () => pocompare_7(),
  getPromise_1: () => getPromise_1(),
  getPromise_2: () => getPromise_2(),
  getPromise_3: () => getPromise_3(),
  getPromise_4: () => getPromise_4(),
  getPromise_5: () => getPromise_5(),
  getPromise_6: () => getPromise_6(),
  getPromise_7: () => getPromise_7(),
  loadData: () => loadData(),
});

export default connect(mapState, mapDispatch)(DashboardNavbar);
